import { Box, MenuItem, Select, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZE_OPTIONS, setPageSize, usePageSize } from '../hooks/pageSize';


export default function Paginator({ numPages, page, setPage }: { numPages: number, page: number, setPage: (page: number) => void }) {
  const { t } = useTranslation()
  const pageSize = usePageSize()

  return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, width: '100%', flexWrap: 'wrap', gap: 2 }}>
    {/* spacer simmetrico al selettore, per mantenere la paginazione centrata */}
    <Box sx={{ flex: 1, display: { xs: 'none', md: 'block' } }} />

    <Pagination
      count={numPages}
      page={page}
      onChange={(_, page) => setPage(page)}
      size="medium"
      shape="rounded"
      showFirstButton
      showLastButton></Pagination>
    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, minWidth: { xs: '100%', md: 0 } }}>
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>{t('general.elementi_per_pagina')}</Typography>
      <Select
        inputProps={{ "aria-label": t("general.elementi_per_pagina") }}
        size="small"
        variant="standard"
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value))
          setPage(1)
        }}
      >
        {PAGE_SIZE_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  </Box>
}
